(function (window, $j) {
    $j(document).ready(function () {
        if (location.protocol === "https:") {
            if ($j("#profile-login").is(":visible")) {
                $j(".my-reservation-button > a").show();
            }
            else {
                if($j(".my-reservation-button").attr("data-property-type") == "Mokara")
                {
                    $j(".my-reservation-button > a").show();
                }
            }
        } else {
            var baseUrl = window.location.host;
            $j.ajax({
                url: "https://" + baseUrl + "/profile/profile/myaccount",
                contentType: "application/json; charset=utf-8",
                data: {},
                type: "GET",
                dataType: "jsonp",
                jsonp: "callback",
                success: function(data) {
                    var model = data.Data;
                    //var loginElement = $j("#profile-login");
                    if (model.IsUserLoggedIn == "true") {
                        //loginElement.text(loginElement.data("profile-label"));
                        //loginElement.attr("href", "#");
                        $j("#profile-login").hide();
                        $j("#profile-dialog").show();
                        $j(".my-reservation-button > a").hide();

                        var fullName = model.FirstName + " " + model.LastName;
                        $j("#profile-image").attr("alt", fullName).attr("title", fullName).attr("src", model.ProfileImageUrl);
                        $j("#profile-image").error(function() {
                            $j("#profile-image").hide();
                        });
                        $j("#membership-number").text(model.MembershipNumber);
                        $j("#first-name").text(model.FirstName);
                        $j("#membership-level").text(model.MembershipLevel);
                        $j("#nights-to-next-level").text(model.NightsToNextLevel);
                        $j("#free-nights").text(model.FreeNights);
                    } else {
                        //loginElement.text(loginElement.data("login-label"));
                        //loginElement.attr("href", loginElement.data("login-url"));
                        $j("#profile-login").show();
                        $j("#profile-dialog").hide();
                        $j(".my-reservation-button > a").show();
                    }
                },
                error: function(data) {
                    $j("#profile-login").show();
                    $j("#profile-dialog").hide();
                    $j(".my-reservation-button > a").show();
                }
            });
        }
    });
})(window, $j);
